import React from "react"
import { Checkbox } from "antd"
import styled from "styled-components"
import theme from "live/services/theme"
import { CheckboxChangeEvent } from "antd/lib/checkbox"
import "antd/lib/checkbox/style/index.css"

const Wrapper = styled.div`
  font-family: ${theme["font-regular"]};
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  box-shadow: unset;
  display: inline-block;
  -webkit-box-shadow: unset;
  .ant-checkbox-wrapper {
    color: ${props => (props.theme === "dark" ? theme['white'] : theme['text-color'])};
  }
  .ant-checkbox {
    .ant-checkbox-inner {
      font-size: 12px;
      width: 12px;
      height: 12px;
    }
  }

  span:not(.ant-checkbox-indeterminate) {
    .ant-checkbox-inner::after {
      width: 4.2855px;
      height: 6.85725px;
      border: 1.5px solid #fff;
      border-top: 0px;
      border-left: 0px;
    }
  }
`

const InputStyled: React.FC<{
  theme: "light" | "dark"
  indeterminate: boolean
  checked: boolean
  children?: HTMLInputElement | string
  onChange: (e: CheckboxChangeEvent) => void
}> = props => {
  return (
    <Wrapper theme={props.theme}>
      <Checkbox
        indeterminate={props.indeterminate}
        checked={props.checked}
        onChange={props.onChange}
      >
        {props.children}
      </Checkbox>
    </Wrapper>
  )
}

export default InputStyled
